import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useScreenSize } from "../..";

import "../../../styles/header.scss";

import logo from "../../../assets/header/logo-primary-color.jpeg";
import vectorDown from "../../../assets/header/vector-down.png";

import { ReactComponent as BasketSvg } from "../../../assets/header/basket.svg";
import { ReactComponent as LoginSvg } from "../../../assets/header/login.svg";
import { ReactComponent as HamburgerSvg } from "../../../assets/header/hamburger.svg";
import { ReactComponent as SearchSvg } from "../../../assets/header/search-primarycolor.svg";
import { ReactComponent as LeftArrowSvg } from "../../../assets/header/left-arrow.svg";

const assetsUri = import.meta.env.ASSETS_URI;

import AppContext from "../../../AppContext";
import ShoppingContext from "../../../contexts/ShoppingContext";
import Menu from "./Menu";
import { profileMenus } from "../../../constants";
import AlgoliaSearch from "../../AlgoliaSearch";

import Cart from "../../Cart/index.jsx";
import PaymentSuccess from "../../Cart/PaymentSuccess.jsx";

import Notification from "../../Notification";
import { langComponent } from "../../../constants";
import { CartContext } from "../../../contexts/CartContext.jsx";

const Header = ({
  isAuth,
  user,
  onNavigateTo,
  onLogin,
  onLogout,
  onClick,
  menus,
  ...props
}) => {
  const { onChildValue } = props;
  const { screenSize } = useScreenSize();
  const { toggleNavbar, setLang, lang, getLang } = useContext(AppContext);
  const { setShoppingFilter } = useContext(ShoppingContext);
  const Translation = getLang(langComponent.header);
  const navigate = useNavigate();
  const [isMobileSearch, setIsMobileSearch] = useState(false);

  // * active link when clicked
  const [activeLink, setActiveLink] = useState("home");
  const [isClick, setIsClick] = useState(false);

  // * store item when mouse hover
  const [currentItem, setCurrentItem] = useState("");

  const [toggleShoppingCart, setToggleShoppingCart] = useState(false);
  const [toggleSuccessModal, setToggleSuccessModal] = useState(false);
  const [detailSuccess, setDetailSuccess] = useState({
    transectionId: "",
    price: 0,
    cardNo: "",
    createDate: "",
  });

  const { items, unavailableItems } = useContext(CartContext);
  const [cartItems, setCartItems] = useState(0);

  /**
   * @param {string} link is path when mouse clicked
   * @returns {string}
   */
  const handleOnShow = (link) => {
    if (isClick) return;

    switch (link) {
      case "shopping":
        onChildValue("shopping");
        return;
      case "art":
        onChildValue("art");
        return;
    }

    onChildValue("out");
  };

  const handleOnLogout = () => {
    onLogout();
    navigate("/");
  };

  const handleNavigateTo = (path) => {
    setIsMobileSearch(false);

    if (path === "/logout") return handleOnLogout();
    if (path === undefined || path === null) return;
    if (path === "/art-designs/community-spaces") {
      setShoppingFilter({
        sort: { createdOn: -1 },
      });
    }
    onNavigateTo(path);
  };

  /**
   * Handle when auth button is clicked
   */
  const handleAuthClick = () => {
    // * Don't trigger anything if already logged in
    if (isAuth) return;
    onLogin();
  };

  const toggleMobile = ["xs", "sm", "md"].includes(screenSize);

  useEffect(() => {
    setCartItems((items?.length ?? 0) + (unavailableItems?.length ?? 0));
  }, [items, unavailableItems]);

  const handleShoppingCartOpen = () => {
    if (isAuth) {
      setToggleShoppingCart(true);
      return;
    }

    onLogin();
  };

  const handleShoppingCartClose = () => {
    setToggleShoppingCart(false);
  };

  const handdleSuccessClose = () => {
    setToggleSuccessModal(false);
  };

  const handleToggleMobileSearchHeader = () => {
    setIsMobileSearch((curr) => !curr);
  };

  return (
    <>
      <header
        className={`urbaan-header ${
          toggleMobile ? "urbaan-header--mobile" : ""
        }`}
      >
        <div className="urbaan-header-content">
          {isMobileSearch && (
            <div className="urbaan-header-content-search">
              <LeftArrowSvg
                width={18}
                onClick={handleToggleMobileSearchHeader}
              />
              <AlgoliaSearch
                handleNavigateTo={handleNavigateTo}
                onClose={handleToggleMobileSearchHeader}
              />
            </div>
          )}
          {!isMobileSearch && (
            <>
              {toggleMobile && (
                <HamburgerSvg
                  className="urbaan-header__hamburger"
                  onClick={() => toggleNavbar()}
                  width={24}
                />
              )}
              {!toggleMobile && (
                <div
                  className="urbaan-header-content__logo"
                  onClick={() => handleNavigateTo("/")}
                >
                  <img src={logo} alt="logo" height={36} />
                </div>
              )}
              <div className="urbaan-header-content-search">
                {!toggleMobile && (
                  <AlgoliaSearch handleNavigateTo={handleNavigateTo} />
                )}
              </div>
              {!toggleMobile && (
                <div className="urbaan-header-content-menus">
                  {menus.map(({ name, menus, path }, i) => {
                    const haveSubMenus =
                      Array.isArray(menus) && menus.length > 0;

                    return (
                      <div
                        key={i}
                        className="urbaan-header-content-menus-menu"
                        onClick={() => handleNavigateTo(path)}
                      >
                        <div className="urbaan-header-content-menus-menu__title">
                          {Translation(name)}
                        </div>
                        {haveSubMenus && (
                          <img
                            className="urbaan-header-content-menus-menu__arrow"
                            src={vectorDown}
                          />
                        )}
                        {haveSubMenus && (
                          <Menu menus={menus} onSelectMenu={handleNavigateTo} />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="urbaan-header-content-ctas">
                {toggleMobile && (
                  <SearchSvg
                    width={25}
                    onClick={handleToggleMobileSearchHeader}
                  />
                )}
                {isAuth && (
                  <div
                    className="urbaan-header-content-basket"
                    onClick={handleShoppingCartOpen}
                  >
                    <div>
                      <BasketSvg
                        className="urbaan-header-content-basket__icon"
                        width={24}
                      />
                      {cartItems > 0 && (
                        <div className="urbaan-header-content-basket__total">
                          <div className="urbaan-header-content-basket__total--inner">
                            {cartItems}
                          </div>
                        </div>
                      )}
                    </div>
                    {toggleSuccessModal && (
                      <PaymentSuccess
                        onClose={handdleSuccessClose}
                        detailSuccess={detailSuccess}
                      />
                    )}
                  </div>
                )}
                {isAuth && (
                  <Notification
                    isPage={false}
                    handleNavigateTo={handleNavigateTo}
                  />
                )}
                <div
                  className="urbaan-header-content-auth"
                  onClick={handleAuthClick}
                >
                  {isAuth && (
                    <>
                      <img
                        className="urbaan-header-content-auth__avatar"
                        alt="avatar"
                        src={`${assetsUri}/${user?.avatar}`}
                        onError={({ target }) => {
                          target.src = user?.avatar;
                        }}
                      />
                      {!toggleMobile && (
                        <>
                          <label className="urbaan-header-content-auth__label--logged-in">
                            {user?.firstname}
                          </label>
                          <img
                            className="urbaan-header-content-menus-menu__arrow"
                            src={vectorDown}
                          />
                        </>
                      )}
                      <Menu
                        menus={profileMenus}
                        onSelectMenu={handleNavigateTo}
                        style={toggleMobile ? { right: 0 } : {}}
                      />
                    </>
                  )}
                  {!isAuth && (
                    <>
                      {!toggleMobile && <LoginSvg />}
                      <label className="urbaan-header-content-auth__label">
                        {Translation("Login/Sign up")}
                      </label>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </header>
      {toggleShoppingCart && (
        <Cart
          onClose={handleShoppingCartClose}
          shopping={items ?? []}
          setToggleSuccessModal={setToggleSuccessModal}
          toggleShoppingCart={toggleShoppingCart}
          setDetailSuccess={setDetailSuccess}
        />
      )}
    </>
  );
};

export default Header;

Header.propTypes = {
  menus: PropTypes.array,
  onNavigateTo: PropTypes.func,
};

Header.defaultProps = {
  menus: [],
  onNavigateTo: () => {},
  onLogin: () => {},
  onChildValue: () => {},
  onClick: () => {},
  isAuth: true,
};
